import * as firebase from 'firebase';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyCIp5BnTOM4WiK7nHN5F_YjOM04rjG1tBk",
    authDomain: "react-mead-expense-fs.firebaseapp.com",
    databaseURL: "https://react-mead-expense-fs.firebaseio.com",
    projectId: "react-mead-expense-fs",
    storageBucket: "react-mead-expense-fs.appspot.com",
    messagingSenderId: "126195105686",
    appId: "1:126195105686:web:4713fa6361aff6ce43a7b7"
};

// Initialize Firebase
//firebase.initializeApp(firebaseConfig);

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const f = firebase;

// Get a reference to the storage service, which is used to create references in your storage bucket
export const storage = firebase.storage();

// Create a storage reference from our storage service
export const storageRef = storage.ref();
export const database = firebase.firestore();






  // const config = {
//     apiKey: process.env.FIREBASE_API_KEY,
//     authDomain: process.env.FIREBASE_AUTH_DOMAIN,
//     databaseURL: process.env.FIREBASE_DATABASE_URL,
//     projectId: process.env.FIREBASE_PROJECT_ID,
//     storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.FIREBASE_APP_ID
// };

// firebase.initializeApp(config);

// const database = firebase.database();
// const googleAuthProvider = new firebase.auth.GoogleAuthProvider();


// export { firebase, googleAuthProvider, database as default };


// const database = firebase.database();
// const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
// export { firebase, googleAuthProvider, database as default };




// WEBPACK FOOTER //
// ./src/firebase/firestore2.js